export interface BulkCancelBookingsParams {
  bookingIds: number[];
  cancellationReason?: string;
  forceCancel?: boolean;
}

export interface BulkCancelBookingsResponse {
  success: boolean;
  message?: string;
  successCount?: number;
  failureCount?: number;
  errors?: string[];
}

export async function bulkCancelBookings(
  params: BulkCancelBookingsParams,
): Promise<BulkCancelBookingsResponse> {
  const response = await fetch('/api/booking/webhook/bulk-cancel-bookings', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      bookingIds: params.bookingIds,
      cancellationReason:
        params.cancellationReason || 'Bulk cancellation via admin interface',
      forceCancel: params.forceCancel ?? false,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to cancel bookings');
  }

  return response.json();
}
